import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { shouldScrollToTop } from "@/lib/scroll-restore";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const previous = useRef<{ pathname: string; hash: string } | null>(null);

  useEffect(() => {
    const next = { pathname, hash };
    if (shouldScrollToTop(previous.current, next)) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    previous.current = next;
    // Mudanças apenas de query string (ex.: ?tab=, ?highlight=) não rolam a página.
  }, [pathname, hash]);

  return null;
}
